import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { PictureInitialParentType } from '~/apollo/generated/v4/graphql';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOPictureManager } from '~/components/upload/supporting-object/so-picture-manager';
import { useShowUnpublished } from '~/components/upload/supporting-object/use-show-unpublished';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';
import {
  countUnpublishedItems,
  isPublished,
} from '~/utils/modules/supporting-object';

const UPLOAD_VOM_PICTURES_PAGE = graphql(`
  query UploadVomPicturesPage($id: ID!) {
    virtualOutcropModelGet(id: $id) {
      id
      pictures {
        ...soManagerPictureParts
      }
    }
  }
`);

export default function UploadVomPicturesPage() {
  return (
    <ApolloProviderV4>
      <UploadVomPicturesPageInner />
    </ApolloProviderV4>
  );
}

function UploadVomPicturesPageInner() {
  const vomId = useRouteParam('vomId', parseInt);

  const { data, loading } = useQuery(UPLOAD_VOM_PICTURES_PAGE, {
    variables: { id: vomId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: UPLOAD_VOM_PICTURES_PAGE,
      variables: { id: vomId },
    },
  ]);

  const vom = data?.virtualOutcropModelGet;
  const allPictures =
    vom?.pictures.slice().sort(R.ascend(p => p.priority ?? Infinity)) ?? [];

  const unpublishedCount = countUnpublishedItems(allPictures);

  const { showUnpublished, PublishedToggle } =
    useShowUnpublished(unpublishedCount);

  const pictures = allPictures.filter(p => showUnpublished || isPublished(p));

  if (loading) return <SpinnerPlaceholder />;
  if (!vom) return <NotFound />;

  return (
    <div className="space-y-4">
      <PublishedToggle />

      <SOPictureManager
        parentType={PictureInitialParentType.VirtualOutcropModel}
        parentId={vomId}
        pictures={pictures}
        refetchQueries={refetchQueries}
      />
    </div>
  );
}
